function isServiceWorkerSupported(): boolean {
  // Check if service workers are available in the browser
  if (!('serviceWorker' in navigator)) {
    return false;
  }

  // Check if we're in a known unsupported environment
  const hostname = window.location.hostname;
  const unsupportedHosts = [
    'stackblitz.com',
    'webcontainer.io',
    'local.stackblitz.com'
  ];

  // Skip service worker in unsupported environments
  if (unsupportedHosts.some(host => hostname.includes(host))) {
    return false;
  }

  return true;
}

export function register() {
  if (!isServiceWorkerSupported()) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('ServiceWorker registered with scope:', registration.scope);
      })
      .catch((error) => {
        // Silently fail if service worker registration is not supported
        console.warn('ServiceWorker registration failed (this is expected in some environments):', error.message);
      });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}